import axiosInstance from 'src/utils/axios';
import {
  AcceptMerchantInvitationPayload,
  CreateMerchantPayload,
  MerchantByCodeQuery,
  MerchantResponse,
  MerchantUserInvitationResponse,
  MerchantUserResponse,
  PatchMerchantPayload,
} from './types.api';

//
//

const BASE_URL = 'merchants/v1';

//

export const getMerchantByIdAPI = async (
  id: string,
  pledgeTaken?: boolean
): Promise<MerchantResponse> => {
  let queryArray = [];
  if (pledgeTaken) queryArray.push('showHasPledged=' + pledgeTaken);
  let queryString = queryArray.length ? '?' + queryArray.join('&') : '';

  const response = await axiosInstance.get<MerchantResponse>(`${BASE_URL}/${id}${queryString}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getMerchantByCodeAPI = async (
  query: MerchantByCodeQuery
): Promise<MerchantResponse> => {
  const { code, pledgeTaken } = query;

  let queryArray = [];
  if (pledgeTaken) queryArray.push('showHasPledged=' + pledgeTaken);
  let queryString = queryArray.length ? '?' + queryArray.join('&') : '';

  const response = await axiosInstance.get<MerchantResponse>(`${BASE_URL}/${code}${queryString}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const patchMerchantAPI = async (
  merchantCode: string,
  data: PatchMerchantPayload
): Promise<MerchantResponse> => {
  const response = await axiosInstance.patch<MerchantResponse>(
    `${BASE_URL}/${merchantCode}/`,
    data
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createMerchantAPI = async (data: CreateMerchantPayload) => {
  return axiosInstance.post(BASE_URL, JSON.stringify(data));
};

export const acceptMerchantInvitationAPI = async (
  merchantCode: string,
  data: AcceptMerchantInvitationPayload
) => {
  return axiosInstance.post(
    `${BASE_URL}/${merchantCode}/users/invitations/accept`,
    JSON.stringify(data)
  );
};

// Merchant Users

export const getMerchantUsersByMerchantCodeAPI = async (
  merchantCode: string
): Promise<MerchantUserResponse> => {
  const response = await axiosInstance.get<MerchantUserResponse>(
    `${BASE_URL}/${merchantCode}/users`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const postMerchantUserInvitationAPI = async (
  merchantCode: string,
  emailAddress: string
): Promise<MerchantUserInvitationResponse> => {
  const response = await axiosInstance.post<MerchantUserInvitationResponse>(
    `${BASE_URL}/${merchantCode}/users/invitations`,
    { emailAddress }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const deleteMerchantUserByIdAPI = async (
  merchantCode: string,
  merchantUserId: string
): Promise<any> => {
  return axiosInstance.delete(`${BASE_URL}/${merchantCode}/users/${merchantUserId}`);
};
